// extracted by mini-css-extract-plugin
export default {"priceRow":"edit-offer_priceRow__lr3UP","priceInput":"edit-offer_priceInput__xGXM9"};